import { mdms } from './api';

export default mdms;
